import type { QontoEmberPartialConfig } from '../../config/environment';

declare const process: { env: Record<string, string | undefined> } | undefined;
const DEFAULT_PLAYWRIGHT_ENVIRONMENT_VARIABLES = {
  backendBranchName: 'qa',
  backendUrlMode: 'local',
  branchName: '',
  checkout: {
    publicKey: 'pk_test_example',
    apiBaseUrl: 'https://api.sandbox.checkout.com',
  },
  deployTarget: 'test',
  eksClusterId: '',
  environment: 'test',
  frontendBranchName: 'sandbox',
  frontendEksClusterId: '',
  frontendUrlMode: 'development',
  googlePay: {
    merchantId: 'test-merchant-id',
  },
  isProduction: false,
  isStaging: false,
  monorepoSuffix: '',
  qontoEventGatewayUrl: '',
  refinerProjectId: '',
  stagingAccessToken: '',
  useQontoEnv: false,
} satisfies QontoEmberPartialConfig;

export const getEnvironmentVariables = (): QontoEmberPartialConfig => {
  if (typeof process !== 'undefined' && Boolean(process?.env.PLAYWRIGHT_TEST)) {
    return DEFAULT_PLAYWRIGHT_ENVIRONMENT_VARIABLES;
  }
  const metaTag =
    typeof document !== 'undefined'
      ? document.querySelector("meta[name^='qonto'][name$='/config/environment']")
      : null;

  const content = metaTag?.getAttribute('content') || '{}';

  try {
    const decodedContent = decodeURIComponent(content);
    return JSON.parse(decodedContent) as QontoEmberPartialConfig;
  } catch (error) {
    console.error('Failed to parse environment variables from meta tag:', error);
    return {} as QontoEmberPartialConfig;
  }
};
